import {
  CHANGE_LAYOUT,
  CHANGE_LAYOUT_WIDTH,
  CHANGE_SIDEBAR_THEME,
  CHANGE_SIDEBAR_THEME_IMAGE,
  CHANGE_SIDEBAR_TYPE,
  CHANGE_TOPBAR_THEME,
  SHOW_SIDEBAR,
  CHANGE_PRELOADER,
  TOGGLE_LEFTMENU,
  SET_DIRECT_ROUTE,
  GO_IDLE,
  GO_ACTIVE,
} from "./actionTypes"

export const changeLayout = (layout: string) => ({
  type: CHANGE_LAYOUT,
  payload: layout,
})

export const changePreloader = (layout: boolean) => ({
  type: CHANGE_PRELOADER,
  payload: layout,
})

export const changeLayoutWidth = (width: string) => ({
  type: CHANGE_LAYOUT_WIDTH,
  payload: width,
})

export const changeSidebarTheme = (theme: string) => ({
  type: CHANGE_SIDEBAR_THEME,
  payload: theme,
})

export const changeSidebarThemeImage = (themeimage: string) => ({
  type: CHANGE_SIDEBAR_THEME_IMAGE,
  payload: themeimage,
})

export const changeSidebarType = (sidebarType: string, isMobile?: boolean) => {
  return {
    type: CHANGE_SIDEBAR_TYPE,
    payload: { sidebarType, isMobile },
  }
}

export const changeTopbarTheme = (topbarTheme: string) => ({
  type: CHANGE_TOPBAR_THEME,
  payload: topbarTheme,
})

export const showSidebar = (isOpen: boolean) => ({
  type: SHOW_SIDEBAR,
  payload: isOpen,
})

export const toggleLeftmenu = (isOpen: boolean) => ({
  type: TOGGLE_LEFTMENU,
  payload: isOpen,
})

export const setDirectRoute = (route: string) => ({
  type: SET_DIRECT_ROUTE,
  payload: route,
})

export const goIdle = () => ({
  type: GO_IDLE,
});

export const goActive = () => ({
  type: GO_ACTIVE,
});

